<template>
    <icon-button
        :data-id-e2e="dataIdE2e"
        :class="['delete-btn']"
        :disabled="isDisabled"
        :events="events"
        icon="custom:trash"
        @click.stop="onClick"
    />
</template>

<script>
import readonly from '@/js/mixins/readonly';

export default {
    mixins: [readonly],
    props: {
        events: Object,
        preventDefault: Boolean,
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        dataIdE2e: String,
    },
    emits: ['delete'],
    computed: {
        isDisabled() {
            return this.disabled || this.isReadOnly;
        },
    },

    methods: {
        onClick() {
            if (this.isDisabled) return;
            if (!this.disabled && !this.preventDefault) this.$emit('delete');
        },
    },
};
</script>
